module.exports = __webpack_public_path__ + "static/media/en.d64b5a48.png";